import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import { TextArea} from 'devextreme-react';
import SelectBox from "../../../../common/CustomSelectBox"
import { factoryProcessVehicleDeliveryTemplateTypes } from "../../../../../Constantes/documentataionRequestTypes";
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors";

function DeliveryRequestForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const typesLoading = useSelector(selectTaxonomyTemplatesLoading)
const [type, setType] = useState(dataForm?.templateCode)


useEffect(()=>{

    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
    
},[])

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    }
},[type, types])

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

function getTemplateIdFromCode(code){
    const {id} = types.find(type=> type.code === code)
    return  id
}

    return(
        <div className={classes.containers} id="documentation-request-form">
              <SelectBox label={"Tipología"} disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} ></SelectBox>
            <div className={"grid-two-columns"}>
                    <TextBox label={"Nome"} labelMode="floating" key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)}  ></TextBox>
                    <TextBox label={"Apellidos"} labelMode="floating" key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)}  ></TextBox>
                    <TextBox label={"Móvil"} labelMode="floating" key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}}  ></TextBox>
                    <TextBox label={"Correo electrónico"} labelMode="floating" key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)}  ></TextBox>
            {
                type == factoryProcessVehicleDeliveryTemplateTypes.FACTORY_PROCESS_TERM &&
                <>
                    <TextBox label={"Nº pedido"} labelMode="floating" key={"requestNumber"} maxLength={9} name="requestNumber" value={dataForm?.requestNumber} onValueChanged={(e) =>{onChange("requestNumber", e.value)}}  ></TextBox>
                    <TextBox label={"Nº contrato"} labelMode="floating" key={"contractNumber"} name="contractNumber" value={dataForm?.contractNumber} onValueChanged={(e) => onChange("contractNumber",e.value)}  ></TextBox>
                </>   
            }
            </div>
                <TextArea label={"Notas"} labelMode="floating" key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)}  height={144}></TextArea>
           
        </div>
    )
}

export { DeliveryRequestForm }